/** Presentation helpers. The backend stores and sends UTC; local time is applied only here. */

const priceFmt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const moneyFmt = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const timeFmt = new Intl.DateTimeFormat(undefined, {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});
const dateTimeFmt = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZoneName: 'short',
});

export const dash = '—';

export function price(v: number | null | undefined): string {
  return v === null || v === undefined || Number.isNaN(v) ? dash : priceFmt.format(v);
}

export function money(v: number | null | undefined, signed = false): string {
  if (v === null || v === undefined || Number.isNaN(v)) return dash;
  const s = moneyFmt.format(v);
  return signed && v > 0 ? `+${s}` : s;
}

export function pct(v: number | null | undefined, digits = 2): string {
  return v === null || v === undefined || Number.isNaN(v) ? dash : `${v.toFixed(digits)}%`;
}

export function ms(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return dash;
  if (v >= 10_000) return `${(v / 1000).toFixed(1)} s`;
  return `${Math.round(v)} ms`;
}

export function lots(v: number | null | undefined): string {
  return v === null || v === undefined ? dash : `${v.toFixed(2)} lot`;
}

export function clock(iso: string | null | undefined): string {
  if (!iso) return dash;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? dash : timeFmt.format(d);
}

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return dash;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? dash : dateTimeFmt.format(d);
}

export function relative(iso: string | null | undefined, now: number = Date.now()): string {
  if (!iso) return dash;
  const diff = (new Date(iso).getTime() - now) / 1000;
  const abs = Math.abs(diff);
  const unit = abs < 90 ? `${Math.round(abs)}s` : abs < 5400 ? `${Math.round(abs / 60)}m` : `${(abs / 3600).toFixed(1)}h`;
  return diff >= 0 ? `in ${unit}` : `${unit} ago`;
}

export function humanize(code: string | null | undefined): string {
  if (!code) return dash;
  const text = code === code.toUpperCase() ? code.toLowerCase() : code;
  return text.replace(/[_.]/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}
